import { Control, useController } from 'react-hook-form'
import { FormControl, FormHelperText, FormLabel, RadioGroup as MuiRadioGroup } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { RadioGroup as RadioGroupProps } from 'elements/RadioGroup/interface'
import validationsToRules from 'utils/validationsToRules'

import { SizingContainer } from '../SizingContainer'

export interface ImageLogicGroupProps {
  control: Control<any>
  gapSize?: number
  textAlign?: 'left' | 'center' | 'right'
  classNames?: string
}

type RadioGroupWrapperProps = Omit<RadioGroupProps, 'options'> &
  Omit<DefaultElementProps, 'children'> &
  ImageLogicGroupProps & {
    children: JSX.Element[]
  }

export default function RadioGroupWrapper({
  name,
  size,
  label,
  children,
  direction,
  defaultValue,
  validations,
  control,
  onFocus,
  onChange,
  gapSize,
  textAlign = 'left',
  classNames,
}: RadioGroupWrapperProps): JSX.Element {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control: control,
    rules: validationsToRules(validations),
  })

  return (
    <SizingContainer className={classNames} size={size}>
      <FormControl
        error={error !== undefined}
        sx={{ width: 1 }}
        required={validations?.required?.value}
      >
        {label !== undefined && <FormLabel>{label}</FormLabel>}
        <MuiRadioGroup
          {...field}
          onFocus={onFocus}
          onChange={(e) => {
            field.onChange(e)
            onChange?.({ value: e.target.value })
          }}
          defaultValue={defaultValue}
          row={direction === 'row'}
          sx={{
            gap: gapSize,
            '& .image-card-txt-wrap': {
              textAlign: textAlign,
            },
          }}
        >
          {children}
        </MuiRadioGroup>
        {error !== undefined && <FormHelperText>{error.message}</FormHelperText>}
      </FormControl>
    </SizingContainer>
  )
}
